import * as yup from 'yup';
import { constantesRequerimentos } from '@utils';
import docs from './attachments';
import {
  acessoContraCheque,
  // acessoJornalForluz,
  adiantamentoQuinzenal,
  consentimentoDescontoFolha,
  parcelaAVista,
  retiradaAVista,
  boletoEmprestimoObrigatorio,
  abatimentoDoEmprestimoCondicional,
  consentimentoBeneficio,
  consentimentoDadosSensiveis,
  aceiteInss,
  tipoRegime,
  aceite,
  declaracaoTipoRegime,
  declaracaoVeracidade,
  consentimentoAjustePagamento,
} from './utils/rulesByKey';

const { TEMPORARIA_FIXO, TEMPORARIA_VARIAVEL } = constantesRequerimentos;

export const MAIANSchema = (saldoDevedor) => {
  if (saldoDevedor) {
    return yup.object({
      opcaoBeneficio: yup
        .string()
        .oneOf(
          [TEMPORARIA_FIXO, TEMPORARIA_VARIAVEL],
          'Obrigatório assinalar uma opção.'
        )
        .required(),

      prazo: yup.string().when('opcaoBeneficio', {
        is: TEMPORARIA_FIXO,
        then: (field) => field.required('Atenção, Selecione o Prazo'),
      }),

      percentualRetiradaMensal: yup
        .number()
        .float(2, 'Máximo de duas casas após a virgula')
        .when('opcaoBeneficio', {
          is: (value) => [TEMPORARIA_VARIAVEL].includes(value),
          then: (field) =>
            field
              .min(0.1, 'Valor deve estar entre 0.10 e 1')
              .max(1, 'Valor deve estar entre 0.10 e 1')
              .required('Atenção, Preencha o Percentual de retirada mensal'),
        }),

      ...consentimentoBeneficio,
      ...adiantamentoQuinzenal,
      ...acessoContraCheque,
      // ...acessoJornalForluz,
      ...consentimentoDescontoFolha,
      ...parcelaAVista,
      ...retiradaAVista,
      ...boletoEmprestimoObrigatorio,
      ...abatimentoDoEmprestimoCondicional,
      ...consentimentoDadosSensiveis(),
      ...declaracaoVeracidade,
      ...consentimentoAjustePagamento,
      ...docs.MAIANDocs.rules,
      ...aceiteInss,
      ...declaracaoTipoRegime,
      ...tipoRegime,
      ...aceite,
    });
  }

  return yup.object({
    opcaoBeneficio: yup
      .string()
      .oneOf(
        [TEMPORARIA_FIXO, TEMPORARIA_VARIAVEL],
        'Obrigatório assinalar uma opção.'
      )
      .required(),

    prazo: yup.string().when('opcaoBeneficio', {
      is: TEMPORARIA_FIXO,
      then: (field) => field.required('Atenção, Selecione o Prazo'),
    }),

    percentualRetiradaMensal: yup
      .number()
      .float(2, 'Máximo de duas casas após a virgula')
      .when('opcaoBeneficio', {
        is: (value) => [TEMPORARIA_VARIAVEL].includes(value),
        then: (field) =>
          field
            .min(0.1, 'Valor deve estar entre 0.10 e 1')
            .max(1, 'Valor deve estar entre 0.10 e 1')
            .required('Atenção, Preencha o Percentual de retirada mensal'),
      }),

    ...consentimentoBeneficio,
    ...adiantamentoQuinzenal,
    ...acessoContraCheque,
    // ...acessoJornalForluz,
    ...consentimentoDescontoFolha,
    ...parcelaAVista,
    ...retiradaAVista,
    ...consentimentoDadosSensiveis(),
    ...declaracaoVeracidade,
    ...consentimentoAjustePagamento,
    ...docs.MAIANDocs.rules,
    ...aceiteInss,
    ...declaracaoTipoRegime,
    ...tipoRegime,
    ...aceite,
  });
};

export const MAIANInitialValues = {
  adiantamentoQuinzenal: '',
  acessoContraCheque: '',
  // acessoJornalForluz: '',
  consentimentoDescontoFolha: false,
  parcelaAVista: '',
  retiradaAVista: '',
  boletoEmprestimo: '',
  abatimentoDoEmprestimo: '',
  opcaoBeneficio: '',
  prazo: '',
  tipoRegime: '',
  declaracaoTipoRegime: false,
  aceite: false,
  percentualRetiradaMensal: '',
  consentimentoBeneficio: false,
  consentimentoDadosSensiveis: false,
  declaracaoVeracidade: false,
  consentimentoAjustePagamento: false,
  aceiteInss: false,
  ...docs.MAIANDocs.initialValues,
};

export const MAIANDocs = {
  ...docs.MAIANDocs.docs,
};
